module.exports = __webpack_public_path__ + "static/media/webauthn-3.b9801bca.svg";